import { isWeb } from 'tamagui'
import { router } from 'expo-router'
import { IProductPaymentOption, IProductVideoCover } from '@dtos/ProductPage'

export const navigateTo = (url: string | null) => {
  if (!url) return
  if (isWeb) {
    window.location.href = url
  } else {
    router.navigate(url)
  }
}

// Matriz de labels do hero_theme: o CTA muda com o tipo de cobrança e, para
// produtos pagos, com o tipo do curso.
export function ctaKind(
  option: IProductPaymentOption | null,
  courseKind: string | null,
) {
  if (option?.kind === 'free') return 'free'
  if (option?.kind === 'subscription') return 'subscription'
  if (courseKind === 'ebook') return 'ebook'
  return 'default'
}

// Vídeo de apresentação com embed público por hostKey; os demais hosts
// (sparkvideos etc.) exigem player assinado e caem na imagem de capa.
export function getVideoEmbedUrl(videoCover: IProductVideoCover | null) {
  if (!videoCover?.hostKey) return null

  const host = (videoCover.host ?? '').toLowerCase()
  if (host === 'youtube') {
    return `https://www.youtube.com/embed/${videoCover.hostKey}`
  }
  if (host === 'vimeo') {
    return `https://player.vimeo.com/video/${videoCover.hostKey}`
  }
  return null
}
